module.exports = __webpack_public_path__ + "img/logo.fea6a50b.png";